import React, { Component } from 'react';
import '../styles/variables.css';
import '../styles/components/header.css';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {startLogout} from '../actions/auth_actions';
import logo from '../images/logo.jpeg'

class Header extends Component {

    state = {
        isLogin: false,
        admin: false
    }

    componentWillMount(){
        if(!!this.props.auth){
            this.setState({isLogin: true})
        }
        if(this.props.admin){
            this.setState({
                admin:true
            })
        }
    }

    logHandler = () =>{
        if(this.state.isLogin){
            this.props.logout();
            window.location.reload(true);
        }else {
            this.props.history.push("/login");
        }
    }

    render(){
        return(
            <nav className="header nav">
                <input type="checkbox" id="nav-toggle" className="toggle-button" />
                <div className="nav-brand shadow" onClick={()=> {this.props.history.push('/')}}>
                    <div className="nav-title">
                        <img src={logo} alt="main-logo" className="main-logo"/>
                        <p className="powered">Powered by: <b className="by-">LaPieza.io</b></p>
                    </div>
                </div>
                {!this.state.admin ? <div className="nav-links">
                    {/*<Link className="link-item" to="/company/vacancies">Categorias</Link>
                    <Link className="link-item" to="/management/dashboard">Comunidad</Link>*/}
                    {this.state.isLogin ? <Link className="link-item" to="/joblisting">Encontrar trabajo</Link> : null}
                    {this.state.isLogin ? <Link className="link-item" to="/profile">Mi Perfil</Link> : null}
                    <button className="account" onClick={this.logHandler}>{this.state.isLogin ? "Salir" : "Iniciar sesión"}</button>
                </div> : null}
                <div className="nav-btn">
                    <label htmlFor="nav-toggle">
                    <span></span>
                    <span></span>
                    <span></span>
                    </label>
                </div>
            </nav>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    logout: () => (dispatch(startLogout()))
})
const mapStateToProps = (state) => ({
    auth: state.auth.uid
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);